import { AppBar, Button, Grid, Toolbar, Typography } from "@mui/material";
import React from "react";
import { useNavigate, NavLink } from "react-router-dom";
import logo from "./../../../assets/cropped-logo.png";

/**
 * Logged-out marketing header only. The logged-in chrome (green stripe, navy
 * bar, greeting, Portal Management, avatar menu) was deleted in the shell
 * refactor — NavRail owns all of it now, including logout. App.tsx therefore
 * renders this only while logged out.
 */
const Header = () => {
  const navigate = useNavigate();

  var currentOrigin = window.location.origin;

  const useSubdomain = (currentOrigin.split(".").length - 1) >= 2 && !currentOrigin.includes("www.")

  var flex_grid_length = useSubdomain ? 8 : 12

  const currentOriginUpdated = currentOrigin.replace("portal.", "")

  return (
    <Grid container item xs={12} sx={{ display: "flex", flexGrow: 1 }}>
        <Grid container sx={{ display: "flex" }}>
          <Grid
            item
            xs={flex_grid_length}
            sx={{
              marginLeft: "10%",
              marginRight: "10%",
              display: "flex",
              alignItems: "center",
              padding: "30px 0",
              flexGrow: 1,
            }}
          >
            <Grid item sx={{ display: "flex", padding: "10px" }}>
              <Typography
                variant="h6"
                noWrap
                component="a"
                href={currentOriginUpdated}
                sx={{
                  mr: 2,
                  display: "flex",
                  fontFamily: "monospace",
                  fontWeight: 700,
                  letterSpacing: ".3rem",
                  color: "black",
                  textDecoration: "none",
                }}
              >
                <img
                  style={{ width: "204", height: "78" }}
                  src={logo}
                  alt={"Zintoro App"}
                />
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexGrow: 1,
                padding: "10px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "22px",
                  color: "#626262",
                  margin: "0",
                  fontWeight: "600",
                }}
              >
                We monitor Key Metrics to Improve Results
              </Typography>
            </Grid>
            <Grid
              // container
              item
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "row",
                padding: "10px",
              }}
            >
              { useSubdomain || (
                <>
                  <Button
                    variant="outlined"
                    sx={{
                      backgroundColor: "#004680",
                      color: "#fff",
                      fontWeight: "bold",
                    }}
                    onClick={() => navigate("/contactus")}
                  >
                    Getting Started
                  </Button>
                  <Button
                    variant="outlined"
                    sx={{
                      backgroundColor: "#004680",
                      color: "#fff",
                      fontWeight: "bold",
                      marginLeft: "10px",
                    }}
                    onClick={() => navigate("/login")}
                  >
                    Login
                  </Button>
                </>
              )}
            </Grid>
          </Grid>
            { useSubdomain || (
              <Grid sx={{ flexGrow: 1 }}>
                <AppBar position="static">
                  <Toolbar
                    variant="dense"
                    disableGutters
                    sx={{
                      backgroundColor: "#004680",
                      display: "flex",
                      justifyContent: "space-between",
                      paddingLeft: "10%",
                      paddingRight: "10%",
                      height: "10px",
                      flexGrow: 1,
                    }}
                  >
                    <NavLink
                      to={"/whyzintoro"}
                      style={({ isActive, isPending, isTransitioning }) => {
                        return {
                          display: "flex",
                          alignItems: "center",
                          textDecoration: isActive ? "underline" : "none",
                          textUnderlineOffset: 5,
                          color: "#fff",
                          fontWeight: "bold",
                        };
                      }}
                    >
                      Why Zintoro
                    </NavLink>
                    <NavLink
                      to={"/howitworks"}
                      style={({ isActive, isPending, isTransitioning }) => {
                        return {
                          display: "flex",
                          alignItems: "center",
                          textDecoration: isActive ? "underline" : "none",
                          textUnderlineOffset: 5,
                          color: "#fff",
                          fontWeight: "bold",
                        };
                      }}
                    >
                      How It Works
                    </NavLink>
                    <NavLink
                      to={"/aboutus"}
                      style={({ isActive, isPending, isTransitioning }) => {
                        return {
                          display: "flex",
                          alignItems: "center",
                          textDecoration: isActive ? "underline" : "none",
                          textUnderlineOffset: 5,
                          color: "#fff",
                          fontWeight: "bold",
                        };
                      }}
                    >
                      About Us
                    </NavLink>
                    <NavLink
                      to={"/whatyoulearn"}
                      style={({ isActive, isPending, isTransitioning }) => {
                        return {
                          display: "flex",
                          alignItems: "center",
                          textDecoration: isActive ? "underline" : "none",
                          textUnderlineOffset: 5,
                          color: "#fff",
                          fontWeight: "bold",
                        };
                      }}
                    >
                      What You Learn
                    </NavLink>
                    <NavLink
                      to={"/results"}
                      style={({ isActive, isPending, isTransitioning }) => {
                        return {
                          display: "flex",
                          alignItems: "center",
                          textDecoration: isActive ? "underline" : "none",
                          textUnderlineOffset: 5,
                          color: "#fff",
                          fontWeight: "bold",
                        };
                      }}
                    >
                      Results
                    </NavLink>
                    <NavLink
                      to={"/ourclients"}
                      style={({ isActive, isPending, isTransitioning }) => {
                        return {
                          display: "flex",
                          alignItems: "center",
                          textDecoration: isActive ? "underline" : "none",
                          textUnderlineOffset: 5,
                          color: "#fff",
                          fontWeight: "bold",
                        };
                      }}
                    >
                      Our Clients
                    </NavLink>
                    <NavLink
                      to={"/ourblog"}
                      style={({ isActive, isPending, isTransitioning }) => {
                        return {
                          display: "flex",
                          alignItems: "center",
                          textDecoration: isActive ? "underline" : "none",
                          textUnderlineOffset: 5,
                          color: "#fff",
                          fontWeight: "bold",
                        };
                      }}
                    >
                      Our Blog
                    </NavLink>
                    <NavLink
                      to={"/ourpartners"}
                      style={({ isActive, isPending, isTransitioning }) => {
                        return {
                          display: "flex",
                          alignItems: "center",
                          textDecoration: isActive ? "underline" : "none",
                          textUnderlineOffset: 5,
                          color: "#fff",
                          fontWeight: "bold",
                        };
                      }}
                    >
                      Our Partners
                    </NavLink>
                    <NavLink
                      to={"/contactus"}
                      style={({ isActive, isPending, isTransitioning }) => {
                        return {
                          display: "flex",
                          alignItems: "center",
                          textDecoration: isActive ? "underline" : "none",
                          textUnderlineOffset: 5,
                          color: "#fff",
                          fontWeight: "bold",
                        };
                      }}
                    >
                      Contact Us
                    </NavLink>
                  </Toolbar>
                </AppBar>
              </Grid> 
            )}
        </Grid>
    </Grid>
  );
};
export default Header;
